import {createSelector} from 'reselect';
import {
    getListingPage,
    getTranslations
} from './store';
import {getBookingUrl} from './bookingUrl';
import {getPriceDetailsData} from './priceDetails';
import {getListingLabels} from './listingLabels';
import {getCurrentError} from './tripAlert';
import getPriceStatus from './priceStatus';
import {getListingCarousel, getBookingType} from './listing';

// Determines if price should be shown
const getShowPrice = createSelector(
    [getListingPage, getCurrentError, getPriceStatus],
    (listingPage, currentError, priceStatus) => {
        const {
            loadingRate
        } = listingPage;

        const {
            isAvailable
        } = priceStatus;

        return !loadingRate && !currentError && isAvailable;
    }
);

const getBookingModalData = createSelector(
    [getCurrentError, getBookingType, getPriceDetailsData, getTranslations, getBookingUrl, getListingLabels, getListingPage, getShowPrice, getListingCarousel],
    (currentError, bookingType, priceDetailsData, translations, bookingUrl, listingLabels, listingPage, showPrice, listingCarousel) => {
        const labels = {
            title: translations.bookingSummary,
            continueButton: translations.onlineBookingModalContinue,
            cancellationPolicyHeader: translations.cancellationPolicyHeader
        };

        if (!bookingType.onlineBookable) {
            labels.continueButton = listingLabels.contactButton;
        }

        const firstImageSrc = listingCarousel.images.length > 0 ? listingCarousel.images[0].src : '';
        return {
            labels,
            ctaEnabled: (!listingPage.loadingRate && bookingUrl && !!bookingUrl.length && !currentError) || !bookingType.onlineBookable,
            showCancellationPolicy: priceDetailsData.totals && Object.keys(priceDetailsData.totals).length > 0,
            showPrice,
            imageSrc: firstImageSrc
        };
    }
);

export default getBookingModalData;

export {getBookingModalData, getShowPrice};
